module.exports = __webpack_public_path__ + "media/assets/icons/talk-bubbles-line-ac041e7c8c30402b33a5f793adc98d69.png";